import { Client } from '@/../client-generator/generated-clients/graylog';
import axios from 'axios';

const graylogClient = new Client('', axios);

export default graylogClient;
